// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".repo-label-item{width:-moz-fit-content;width:fit-content;height:-moz-fit-content;height:fit-content;min-height:22px;padding:2px 8px;display:flex;align-items:center;font-size:12px;line-height:1.2;border-radius:14px}.repo-label-item>i{cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
